"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const AudienceLink_1 = require("../../components/AudienceLink");
const NoTestDevicesForDesktop = () => (React.createElement(AudienceLink_1.default, { primaryText: "No test devices found.", secondaryText: "Manage Test Devices", style: {
        height: '100%',
        width: '100%',
    } }));
const NoTestDevicesForTablets = () => (React.createElement("div", { style: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
    } },
    React.createElement(src_1.Text, { text: "No test devices found. Manage test devices in the Audience App.", size: "large", textStyle: {
            width: 327,
            textAlign: 'center',
        } })));
const NoTestDevicesForMobile = () => (React.createElement(src_1.Text, { text: "No test devices found. Manage test devices in the Audience App.", size: "large", textStyle: {
        width: 327,
        marginTop: 8,
    } }));
const NoTestDevices = ({ userDeviceType }) => {
    switch (userDeviceType) {
        case 'Desktop':
            return React.createElement(NoTestDevicesForDesktop, null);
        case 'Tablet':
            return React.createElement(NoTestDevicesForTablets, null);
        case 'Mobile':
            return React.createElement(NoTestDevicesForMobile, null);
    }
    return React.createElement(NoTestDevicesForDesktop, null);
};
exports.default = NoTestDevices;
